import { getResponse } from '@satellite/services/serviceUtilities';

export default {
  /**
   * Whether the container behind a Ready for Pickup deep link can still take a pickup appointment.
   * Answers 200 with a reason instead of an error, so a dead link is a normal screen state.
   *
   * @param {string} assetContainerId
   * @param {string} warehouseId
   * @param {object} [options]
   * @param {import('axios').AxiosRequestConfig} [requestConfig]
   * @returns {Promise<{ available: boolean, reason?: string, assetContainer?: object }>}
   */
  async getPickupAvailability(assetContainerId, warehouseId, options = {}, requestConfig = {}) {
    const response = await axios.get(`asset-container/${assetContainerId}/pickup-availability`, {
      ...requestConfig,
      params: { ...requestConfig.params, warehouseId }
    });

    return getResponse(response, options);
  }
};
